/**
 * Info section for editing linkedTable name and description
 */

import { Input, Label, Textarea } from '@loader/ui';

interface InfoSectionProps {
  /** Whether the user can edit (false for viewers) */
  canEdit?: boolean;
  linkedTableName: string;
  linkedTableDescription: string;
  onUpdateName?: (name: string) => void;
  onUpdateDescription?: (description: string) => void;
}

/**
 * Section for editing linkedTable name and description
 */
export function InfoSection({
  canEdit = true,
  linkedTableName,
  linkedTableDescription,
  onUpdateName,
  onUpdateDescription,
}: InfoSectionProps) {
  return (
    <div className="space-y-3">
      {/* LinkedTable Name Input */}
      <div className="space-y-1.5">
        <Label htmlFor="linkedTable-name" className="text-xs text-muted-foreground">
          Name
        </Label>
        <Input
          id="linkedTable-name"
          value={linkedTableName}
          onChange={(e) => onUpdateName?.(e.target.value)}
          placeholder="Enter linkedTable name"
          className="bg-background h-8 text-sm"
          disabled={!canEdit}
        />
      </div>

      {/* LinkedTable Description Textarea */}
      <div className="space-y-1.5">
        <Label htmlFor="linkedTable-description" className="text-xs text-muted-foreground">
          Description
        </Label>
        <Textarea
          id="linkedTable-description"
          value={linkedTableDescription}
          onChange={(e) => onUpdateDescription?.(e.target.value)}
          placeholder="Enter linkedTable description"
          className="bg-background min-h-[60px] resize-none text-sm"
          disabled={!canEdit}
        />
      </div>
    </div>
  );
}

